import { Component } from "react";
import PlatForm from "./PlatForm";

export default class App extends Component{
    constructor(props){
        super()
    }
    render(){
        return(
            <>
            <PlatForm/>
            </>
        )
    }
}
